import {
  POST,
  GET,
  FILE
} from '@/axios/axios'

export const services = {
  getSignUrl: (param) => { // 获取e签宝签约url
    return GET('/auth/custom/api/findSignUrl', param);
  },

}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/home.js